import formCreate from '@form-create/element-ui';
var viewForm = formCreate.factory();
var designerForm = formCreate.factory();
export default viewForm;
export { designerForm };